import { useEffect } from "react";
import "@/index.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Packages from "@/components/landing/Packages";
import WhyChoose from "@/components/landing/WhyChoose";
import Experiences from "@/components/landing/Experiences";
import EnquiryForm from "@/components/landing/EnquiryForm";
import ContactCTA from "@/components/landing/ContactCTA";
import BeachGallery from "@/components/landing/BeachGallery";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-navy-abyss min-h-screen text-ivory">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Packages />
        <Experiences />
        <BeachGallery />
        <WhyChoose />
        <EnquiryForm />
        <ContactCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
